import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { permissionsEnumSchema } from "@mindlercare/schema";
import { useMindlerApi } from "api/apiv2";
import { hasPermissions } from "helpers/permissions";
import { useCurrentUser, useUserHasRole } from "hooks/userHooks";
import { useTranslation } from "react-i18next";
import useMarketStrategy from "strategies/market/useMarketStrategy";
import { PatientInsuranceInfo } from "./patientInsuranceMembership";
import PatientItem from "./patientItem";
import { SavedCardStatus } from "./SavedCardStatus";

export const InsuranceInfo = ({
  patientUserId,
}: {
  patientUserId?: string | number;
}) => {
  const { t } = useTranslation();
  const {
    showInsuranceInfoPsychologist,
    showInsuranceInfoAdmin,
    showInsurancePlan,
    showSavedCardStatus,
  } = useMarketStrategy();
  const isAdmin = useUserHasRole("Admin");
  const isPsychologist = useUserHasRole("Psychologist");
  const showInsuranceInfo =
    (isAdmin && showInsuranceInfoAdmin) ||
    (isPsychologist && showInsuranceInfoPsychologist);
  const { user } = useCurrentUser();
  const userHasPaymentsPermission = hasPermissions(
    user,
    permissionsEnumSchema.enum.USER_PAYMENTS,
  );

  const api = useMindlerApi();
  const { data: insuranceInfoKey } = useQuery(
    api.b2bMemberships.getLatestB2BMembershipKey.queryOptions(
      {
        userId: Number(patientUserId),
      },
      { enabled: !!patientUserId },
    ),
  );

  return (
    <>
      {showInsuranceInfo && insuranceInfoKey?.key && (
        <PatientInsuranceInfo
          insuranceInfoKey={insuranceInfoKey}
          patientUserId={patientUserId}
        />
      )}
      {showSavedCardStatus && isAdmin && userHasPaymentsPermission && (
        <SavedCardStatus patientUserId={patientUserId} />
      )}
      {showInsurancePlan && insuranceInfoKey?.planName && (
        <PatientItem
          title={t("INSURANCE_PLAN")}
          value={
            insuranceInfoKey.quotaExtendable
              ? `${t(insuranceInfoKey.planName)}: ${t(
                  "ADDITIONAL_SESSIONS_ON_REQUEST",
                )}`
              : t(insuranceInfoKey.planName)
          }
        />
      )}
    </>
  );
};
